import axios from 'axios';
import { config } from '../../config';

export default {
    namespaced: true, // ← IMPORTANTE: Activa el namespacing para este módulo

    actions: {
        async precio_get() {
            return new Promise((resolve, reject) => {
                axios.get(config.apiUrl + '/precio/get')
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async precio_getPorcentajeReserva() {
            return new Promise((resolve, reject) => {
                axios.get(config.apiUrl + '/precio/get-porcentaje-reserva')
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async precio_update(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/precio/update', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async precio_updatePorcentajeReserva(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/precio/update-procentaje-reserva', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        }
    }
}